(function () {
  var instances = [];

  function initSection(section) {
    if (section.dataset.tpBound) return;
    section.dataset.tpBound = '1';
    var track = section.querySelector('.custom-tp__track');
    var grid = section.querySelector('.custom-tp__grid');
    var prevBtn = section.querySelector('.custom-tp__nav--prev');
    var nextBtn = section.querySelector('.custom-tp__nav--next');
    if (!track || !grid || !prevBtn || !nextBtn) return;

    var scrollAmount = 340;
    var autoPlayDelay = 3000;
    var autoPlayTimer = null;

    /* ---- Navigation state ---- */
    function updateNav() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      restartAutoPlay();
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      restartAutoPlay();
    });

    track.addEventListener('scroll', updateNav, { passive: true });
    updateNav();

    /* ---- Auto-play + infinite loop ---- */
    function autoScroll() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (Math.round(track.scrollLeft) >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    function startAutoPlay() {
      stopAutoPlay();
      autoPlayTimer = setInterval(autoScroll, autoPlayDelay);
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer);
        autoPlayTimer = null;
      }
    }

    function restartAutoPlay() {
      stopAutoPlay();
      setTimeout(startAutoPlay, autoPlayDelay);
    }

    section.addEventListener('mouseenter', stopAutoPlay);
    section.addEventListener('mouseleave', startAutoPlay);

    startAutoPlay();

    /* ---- Drag to scroll ---- */
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      track.style.userSelect = 'none';
      stopAutoPlay();
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - startX;
      track.scrollLeft = scrollStart - dx;
    });

    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      track.releasePointerCapture(e.pointerId);
      track.style.cursor = '';
      track.style.scrollSnapType = '';
      track.style.userSelect = '';
      restartAutoPlay();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    /* Prevent click on links/buttons after drag */
    track.addEventListener('click', function (e) {
      if (Math.abs(track.scrollLeft - scrollStart) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* Store instance for cleanup */
    instances.push({
      section: section,
      destroy: function () {
        stopAutoPlay();
        section.removeEventListener('mouseenter', stopAutoPlay);
        section.removeEventListener('mouseleave', startAutoPlay);
      }
    });
  }

  document.querySelectorAll('.custom-tp').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.custom-tp');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.custom-tp');
    instances = instances.filter(function (inst) {
      if (inst.section === section) {
        inst.destroy();
        delete section.dataset.tpBound;
        return false;
      }
      return true;
    });
  });
})();
